import React from "react";
import { styled } from "@glitz/react";

interface ProductTitleProps {
  title: string;
  left?: boolean;
}

const ProductTitle: React.FC<ProductTitleProps> = ({ title, left }) => {
  return (
    <ProductTitleWrapper css={left && LeftStyles}>
      <h1>{title}</h1>
    </ProductTitleWrapper>
  );
};
const ProductTitleWrapper = styled.div({
  textAlign: "center",
});
const LeftStyles = styled({
  textAlign: "left",
});

export default ProductTitle;
